export default "__VITE_ASSET__DBgsK19Q__"